export const emptyString = '';
export const emptyArray = Object.freeze([]);
export const emptyObject = Object.freeze({});
export const defaultDates = Object.freeze(['0001-01-01T00:00:00.000Z', '0001-01-01T00:00:00', '0001-01-01']);
export const emptyCity = Object.freeze({ id: null, name: null });
export const chassisNumberLength = 17;
export const cascoLoadingFakeCardsNo = 4;
export const showModifiedQuotationMs = 5000;
export const partnerIdentityDocumentValidityDays = 30;
export const systemGeneratedUniqueIdPrefix = 'KEYS';
export const maleDigits = Object.freeze([1, 3, 5, 7]);
export const femaleDigits = Object.freeze([2, 4, 6, 8]);
export const maleGender = 'M';
export const femaleGender = 'F';
export const sidebarWrapperHeight = 'calc(100vh - 115px)';
export const emptyFunction = () => {};
export const insuranceTypeNames = Object.freeze({
  RCA: 'RCA',
  CASCO: 'CASCO',
  RTI: 'RTI'
});
export const QuotationsStatus = Object.freeze({
  VALID: 'VALID',
  EXPIRED: 'EXPIRED',
  PROCESSING: 'PROCESSING',
  COMPUTING: 'COMPUTING'
});
export const DocumentVerificationStatus = Object.freeze({
  IN_PROGRESS: 'IN_PROGRESS'
});

export const identityDocumentTypes = Object.freeze({
  CI: 'CI'
});

export const engineTypeCodes = Object.freeze({
  ELECTRIC: 'ELECTRIC'
});

export const defaultPager = Object.freeze({
  page: 0,
  pageSize: 5,
  totalCount: 0,
  totalPages: 0
});

export function orderDirection(t) {
  return [
    { name: t('General.Ascending'), value: 1 },
    { name: t('General.Descending'), value: 0 }
  ];
}

export const applicationFeatureCodes = Object.freeze({
  ENABLE_OCR_INTEGRATION: 'ENABLE_OCR_INTEGRATION'
});

export const assetFieldsMaxValue = Object.freeze({
  cylindricCapacity: 99999,
  enginePower: 9999,
  maxWeight: 99999,
  seatsNumber: 99,
  currentMileage: 10000000,
  purchasePrice: 9999999999
});
